<template>
  <div class="tooltip" :class="[containerClass, cursor]" ref="tooltip">
    <v-tooltip
      :left="alignment === 'left'"
      :right="alignment === 'right'"
      :bottom="alignment === 'bottom'"
      :top="alignment === 'top'"
      :content-class="contentClasses"
      :max-width="maxWidth"
      :disabled="isDisabled"
    >
      <template v-slot:activator="{ on }">
        <!-- hiddenTxt : 히든처리 전체 텍스트 (height 측정용) -->
        <span ref="hiddenTxtSpan" v-html="text" class="hiddenTxt" :style="{ maxWidth: txtMaxWidth ? txtMaxWidth + unit : 'none', height: isIcon ? '26px': '', width: isIcon ? '26px': '' }"></span>
        <!-- showTxt : 실제 노출되는 ... 표시된 텍스트 (노출용) -->
        <span v-if="!isIcon" @mouseover="getShowTooltip" v-on="on" class="showTxt clampTxt" :class="classes" v-html="text">
        </span>
        <!-- icon : 아이콘 일경우 툴팁은 무조건 노출됨 (반대로 텍스트 경우에는 hiddenTxt의 height 가 txtMaxHeight 보다 넘을경우 노출)-->
        <i v-else @mouseover="getShowTooltip" v-on="on" :class="classes" :style="{'color': iconColor, 'backgroundPosition': backgroundPosition}" @click="events"></i>
      </template>
      <!-- 툴팁에 노출되는 텍스트 -->
      <pre v-html="showTooltipTxt || text"></pre>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'tooltip',
  data () {
    return {
      isClampTxt: false,
      txtMinWidth: 0,
      showTooltip: false
    }
  },
  props: {
    text: {
      type: String,
      required: true
    },
    containerClass: {
      type: String,
      default: '',
      required: false
    },
    contentClasses: {
      type: String,
      default: 'tooltipDefault',
      required: false
    },
    classes: {
      type: String,
      default: '',
      required: false
    },
    iconColor: {
      type: String,
      default: '#919191',
      required: false
    },
    isIcon: {
      type: Boolean,
      default: false,
      required: false
    },
    events: {
      type: Function,
      default: () => {},
      required: false
    },
    alignment: {
      type: String,
      default: 'bottom',
      required: false
    },
    maxWidth: {
      type: Number,
      default: 400,
      required: false
    },
    txtMaxWidth: { // ie 대응 위함, 필요한 경우 maxWidth 와 동일한 값 줘야함
      type: [String, Number],
      default: 0,
      required: false
    },
    txtMaxHeight: {
      type: [String, Number],
      default: 40,
      required: false
    },
    showTooltipTxt: {
      type: String,
      required: false,
      default: ''
    },
    unit: {
      type: String,
      required: false,
      default: 'px'
    },
    backgroundPosition: {
      type: [String, Object],
      default: null,
      required: false
    }
  },
  watch: {
    text: {
      immediate: true,
      handler () {
        this.getShowTooltip()
      }
    },
    txtMinWidth () {
      this.getShowTooltip()
    },
    txtMaxWidth () {
      this.getShowTooltip()
    }
  },
  methods: {
    getShowTooltip () {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.tooltip && this.$refs.hiddenTxtSpan) {
            this.txtMinWidth = this.$refs.tooltip.parentNode.offsetWidth + 'px'
            this.isClampTxt = this.$refs.hiddenTxtSpan.offsetHeight > Number(this.txtMaxHeight)
          }
        })
      })
    }
  },
  computed: {
    isDisabled () {
      return this.isIcon ? false : !this.isClampTxt
    },
    cursor () {
      return this.isDisabled ? '' : 'cursor'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tooltip.vue